export function ClockTimeoutIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_14723_20359)'>
        <path
          d='M8.25 8.5H10.75L8.25 11H10.75M10.9753 6.5C10.9916 6.33555 11 6.16875 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C6.08383 11 6.16718 10.9979 6.25 10.9939C6.33389 10.9897 6.41724 10.9835 6.5 10.9753M6 3V6L7.86919 6.93459'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_14723_20359'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
